module.exports = __webpack_public_path__ + "static/img/14000003.e5286b0a.png";